var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-select',{staticClass:"limit",attrs:{"label":"Limit","prepend-icon":"mdi-filter-variant","items":_vm.items,"dense":"","hide-details":"","menu-props":{ bottom: true, offsetY: true },"outlined":""},on:{"change":_vm.changed},model:{value:(_vm.limit),callback:function ($$v) {_vm.limit=$$v},expression:"limit"}})
}
var staticRenderFns = []

export { render, staticRenderFns }